<template>
  <div class="upload">
    <el-upload
      class="upload-demo"
      :file-list="attach_urls"
      :action="UploadUrl()"
      :on-success="handleChange"
      :on-remove="handleRemove"
      :before-upload="beforeAvatarUpload"
      accept=".rar, .zip, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .jpg, .png"
      ref="hhh"
      :data="uploadType"
    >
      <el-button size="small" icon="el-icon-upload" style="float: left;">{{title}}</el-button>
      <!-- <div style="width: 425px;height: 120px;border: 1px solid #DCDFE6;margin-top: 50px;" v-if="logintype == 'KEFU'"> -->
      <div class="noStyle" slot="tip" v-if="logintype == 'KEFU'" @click="changshi">
        <div style="margin-top: 20px;">
          截图粘贴图片上传
        </div>
        <div style="color: #999999;">
          暂支持聊天工具截图，点击本区域后Ctrl+V粘贴图片
        </div>
      </div>
      <div
        slot="tip"
        class="el-upload__tip"
      >支持扩展名：.rar .zip .doc .docx .xls .xslx .ppt .pptx .pdf .jpg .png格式,附件单个上传大小限制50M。</div>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "uploadAdjunct",
  props: {
    title: {
      type: String,
      default: "点击上传"
    },
    imgList:{
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: function() {
    return {
      attach_urls: [],
      logintype: '',
      uploadType: {
        tong: 'commonForm2'
      },
    };
  },
  mounted() {
    // document.addEventListener('paste', this.onPasteUpload)
    this.logintype = JSON.parse(localStorage.getItem("userData")).logintype; //登录账号类型
  },
  beforeDestroy() {
    document.removeEventListener('paste', this.onPasteUpload)
  },
  created(){
    this.imgList.map(item=>{
      this.attach_urls.push({
        name: item,
        url: item
      });
    })
    console.log( this.attach_urls)
  },
  methods: {
    changshi() {
      document.addEventListener('paste', this.onPasteUpload)
    },
    UploadUrl() {
      return "hcm/hcmWorkOrder/headUpload";
    },
    handleChange(file, fileList) {
      this.loadingUpDe = false;
      if (file.data.code == 2000) {
        this.$message.error(file.data.msg);
      }
      if (file.data.code == 0) {
        this.$message({
          message: file.data.msg,
          type: "success"
        });
      }
      this.attach_urls.push({
        name: fileList.name,
        url: fileList.response.data.data
      });
      console.log(this.attach_urls);
      this.$emit("attachUrls", this.attach_urls);
    },
    beforeAvatarUpload(file) {
      this.loadingUpDe = true;
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 50MB!");
      }
      return isLt2M;
    },
    onPasteUpload(e) {
      console.log(e)
      const upload = this.$refs.hhh
      if (!upload) {
        return
      }
      const items = e.clipboardData.items
      for (const item of items) {
        if (item.type === 'image/png') {
          const file = new File([item.getAsFile()], new Date().getTime() + '.png')
          upload.handleStart(file)
        }
      }
      upload.submit()
    },
    handleRemove(file, fileList) {
      for (var i in this.attach_urls) {
        if (
          this.attach_urls[i].name == file.name &&
          this.attach_urls[i].url == file.url
        ) {
          this.attach_urls.splice(i, 1);
        }
      }
      this.$emit("attachUrls", this.attach_urls);
    },
    clearUrls() {
      this.attach_urls = [];
      this.$set(this, "attach_urls", []);
      console.log(this.attach_urls);
    },

  }
};
</script>

<style lang="scss">
.upload {
  .el-upload__tip {
    font-size: 12px;
    color: #999999;
    line-height: 25px;
  }
}
.noStyle {
  width: 425px;
  height: 120px;
  border: 1px solid #DCDFE6;
  text-align: center;
  cursor: pointer;
}
.noStyle:hover {
  border: 1px solid #409EFF;
  color: #409EFF;
}
</style>
